import ApiClient from "../api-client";
import { cacheService, EnvType } from "../services";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetMarkersResponse } from "../Types/get-markers-response";
import ThumbnailApiClient from "./thumbnail-api-client";

export enum ThumbnailSize {
  original = "original",
  small = "small",
  medium = "medium",
  xmedium = "xmedium",
  large = "large",
  xlarge = "xlarge",
  xxlarge = "xxlarge",
}
export default class ThumbnailService {
  thumbnailApiClient: ThumbnailApiClient;

  constructor(envType: EnvType) {
    this.thumbnailApiClient = new ThumbnailApiClient(new ApiClient(envType), envType);
  }

  GetObjectPosterUrl(titleObjectId: number | undefined, size: ThumbnailSize = ThumbnailSize.xlarge): string {
    const lastUdpatedMediaTimestamp = cacheService.GetLastUpdatedMediaTimestamp();
    let url =
      this.thumbnailApiClient.GetApiUrl() +
      "/thumbs/reference/" +
      (size ? ThumbnailSize[size].toString() + "/" : "") +
      cacheService.GetAuthKey() +
      "/" +
      titleObjectId;

    if (lastUdpatedMediaTimestamp) {
      url += "?t=" + lastUdpatedMediaTimestamp;
    }

    return url;
  }

  GetSharePosterUrl(size: ThumbnailSize = ThumbnailSize.xlarge, shareKey: string): string {
    const lastUdpatedMediaTimestamp = cacheService.GetLastUpdatedMediaTimestamp();
    return (
      this.thumbnailApiClient.GetApiUrl() +
      "/thumbs/reference/share/" +
      (size ? ThumbnailSize[size].toString() + "/" : "") +
      shareKey +
      "t?=" +
      lastUdpatedMediaTimestamp
    );
  }

  async CreateThumbReference(objectId: number, frame: number): Promise<GenericResponseStd> {
    return await this.thumbnailApiClient.CreateThumbReference(objectId, frame);
  }

  //-----------------Useless-----------------

  async CleanCacheThumbRefByObjectId(objectId: number): Promise<GenericResponseStd> {
    return await this.thumbnailApiClient.CleanCacheThumbRefByObjectId(objectId);
  }
  async GetSceneThumbsByObjectId(objectId: number): Promise<GetMarkersResponse> {
    return await this.thumbnailApiClient.GetSceneThumbsByObjectId(objectId);
  }
  GetRollThumbsVttTrackByObjectId(objectId: number, authKey: string): string {
    return this.thumbnailApiClient.GetRollThumbsVttTrackByObjectId(objectId, authKey);
  }
  GetRollThumbsSpliceImageByObjectId(objectId: number, authKey: string, frameIn: number): string {
    return this.thumbnailApiClient.GetRollThumbsSpliceImageByObjectId(objectId, authKey, frameIn);
  }
  GetMergeThumbsSpliceImageByObjectId(objectId: number, segments: number, authKey: string): string {
    return this.thumbnailApiClient.GetMergeThumbsSpliceImageByObjectId(objectId, segments, authKey);
  }
  GetShareThumbRefCompressedByObjectId(size: ThumbnailSize, shareKey: string): string {
    return this.thumbnailApiClient.GetShareThumbRefCompressedByObjectId(size, shareKey);
  }
  GetThumbRefByObjectId(objectId: number, authKey: string, size?: ThumbnailSize): string {
    const lastUdpatedMediaTimestamp = cacheService.GetLastUpdatedMediaTimestamp();
    let url = this.thumbnailApiClient.GetThumbRefByObjectId(objectId, authKey, size);
    if (lastUdpatedMediaTimestamp) {
      url += "?t=" + lastUdpatedMediaTimestamp;
    }
    return url;
  }
  async GenerateMarkerThumbnailsByObjectId(objectId: number): Promise<GenericResponseStd> {
    return await this.thumbnailApiClient.GenerateMarkerThumbnailsByObjectId(objectId);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.thumbnailApiClient.GetApiUrl();
  }
}
